import { get } from 'lodash-es';
import type { FieldValues } from 'react-hook-form';

import { formatFieldKeyOut } from '../../fields/FieldUtils';
import type { Document, WorkflowStepFormFieldBlock } from '../../types';
import { applyTransformFuncs } from '../general';
import { getFlattenedFormFieldBlocks } from './getFlattenedFormFieldBlocks';

export const getFieldValuesFromFormBlocks = (
  formFieldBlocks: WorkflowStepFormFieldBlock[],
  document: Document<any> | Record<string, any> | undefined,
): FieldValues => {
  let fieldValues: FieldValues = {};
  const flattenedFormFieldBlocks = getFlattenedFormFieldBlocks(formFieldBlocks);

  flattenedFormFieldBlocks.forEach((block) => {
    let value = get(document, formatFieldKeyOut(block.name));

    // Apply transform funcs
    if (block.transformFuncsIn && value !== undefined) {
      value = applyTransformFuncs(value, block.transformFuncsIn);
    }

    if (value === null) {
      value = undefined;
    }

    // Cast back to string
    if (value !== undefined && typeof value !== 'string') {
      value = `${value}`;
    }

    fieldValues = {
      ...fieldValues,
      [block.name]: value,
    };
  });

  return fieldValues;
};
